import { render, staticRenderFns } from "./teamsList.vue?vue&type=template&id=4add6846&"
import script from "./teamsList.vue?vue&type=script&lang=js&"
export * from "./teamsList.vue?vue&type=script&lang=js&"
import style0 from "./teamsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports